const DOCUMENT = 'FURNITURE';

export const GET_FURNITURES = DOCUMENT + 'GET_FURNITURES';
export const GET_FURNITURES_SUCCESS = DOCUMENT + 'GET_FURNITURES_SUCCESS';
export const GET_FURNITURES_ERROR = DOCUMENT + 'GET_FURNITURES_ERROR';
